export const UPDATE_CONVERSATION_VIEWER_SELECTED_ADJUSTER = "UPDATE_CONVERSATION_VIEWER_SELECTED_ADJUSTER";
export const UPDATE_FROM_ADJUSTER = "UPDATE_FROM_ADJUSTER";
export const UPDATE_TO_ADJUSTER = "UPDATE_TO_ADJUSTER";
export const UPDATE_BATCH_TYPE = "UPDATE_BATCH_TYPE";